import styled from "styled-components";

export const WeekDayStripStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[12]};
  width: 100%;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing[12]};
  }

  .monthLabel {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.title.t2.size};
    line-height: ${({ theme }) => theme.typography.title.t2.lineHeight};
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .navButton {
    width: 32px;
    height: 32px;
    border-radius: ${({ theme }) => theme.radius.rounded};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover {
      background: ${({ theme }) => theme.colors.accent[50]};
      border-color: ${({ theme }) => theme.colors.semantic.outline.hover};
    }
  }

  .strip {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: ${({ theme }) => theme.spacing[8]};
    overflow-x: auto;
    scroll-behavior: smooth;
    padding-bottom: 2px;
  }

  .dayCell {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[4]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border-radius: ${({ theme }) => theme.radius[12]};
    cursor: pointer;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    transition: background 0.15s ease, border-color 0.15s ease,
      transform 0.1s ease;
    min-width: 0;

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.accent[50]};
      border-color: ${({ theme }) => theme.colors.semantic.outline.hover};
    }
  }

  .dayCell.selected {
    border: 1.5px solid ${({ theme }) => theme.colors.semantic.text.strong};
    background: ${({ theme }) => theme.colors.semantic.container.white};
  }

  .dayCell.today .dayNumber {
    background: ${({ theme }) => theme.colors.accent[200]};
    color: ${({ theme }) => theme.colors.semantic.container.white};
    border-radius: 50%;
  }

  .dayCell.disabled {
    color: ${({ theme }) => theme.colors.semantic.text.placeholder};
    background: ${({ theme }) => theme.colors.semantic.container.gray};
    cursor: not-allowed;
  }

  .weekday {
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  .dayNumber {
    font-size: ${({ theme }) => theme.typography.title.t1.size};
    line-height: 28px;
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    min-width: 28px;
    min-height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .monthMini {
    font-size: 10px;
    line-height: 12px;
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }
`;
